import { render, staticRenderFns } from "./addxunjz.vue?vue&type=template&id=53edbf78"
import script from "./addxunjz.vue?vue&type=script&lang=js"
export * from "./addxunjz.vue?vue&type=script&lang=js"
import style0 from "./addxunjz.vue?vue&type=style&index=0&id=53edbf78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports